import React from "react";
import { LogOut } from "lucide-react";

import { useTranslation } from "../context/Internationalization";
import { Button } from "../shadcn/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../shadcn/components/ui/dialog";

const LogoutConfirmationModal = ({ open, onClose, logout }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={Boolean(open)}
      onOpenChange={(next, details) => !next && onClose?.(details?.event)}
    >
      <DialogContent closeLabel={t("close")}>
        <DialogHeader>
          <DialogTitle>{t("logout")}</DialogTitle>
          <DialogDescription>
            {t("are_you_sure_you_want_to_logout")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            {t("close")}
          </Button>
          <Button type="button" variant="destructive" onClick={logout}>
            <LogOut aria-hidden="true" />
            {t("logout")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutConfirmationModal;
